import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const RefCtx = createContext({ categories: [], cities: [] });

export const RefDataProvider = ({ children }) => {
  const { data: categories = [] } = useQuery({ queryKey: ["categories"], queryFn: async () => (await api.get("/categories")).data });
  const { data: cities = [] } = useQuery({ queryKey: ["cities"], queryFn: async () => (await api.get("/geo/cities")).data, staleTime: Infinity });
  const { data: settings } = useQuery({ queryKey: ["public-settings"], queryFn: async () => (await api.get("/settings/public")).data });
  return <RefCtx.Provider value={{ categories, cities, settings }}>{children}</RefCtx.Provider>;
};

export const useRefData = () => useContext(RefCtx);
